export const authRoutes = [
  {
    path: "/login",
    name: "Login",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/auth/Login.vue")
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "@/views/auth/ForgotPassword.vue"
      )
  },
  {
    path: "/reset/:uid/:token",
    name: "ResetPassword",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "@/views/auth/ResetPassword.vue"
      )
  },
  {
    path: "/auth/azure/callback",
    name: "AzureCallback",
    meta: { requiresAuth: false },
    component: () => import("@/views/auth/AzureCallback.vue")
  }
];
